import UnionPayWindow from "./UnionPayWindow";
import { withRouter } from "react-router-dom";

export default withRouter(UnionPayWindow);
